import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  formattedCell: {
    display: 'flex'
  },
  formattedWrappedCell: {
    display: 'block',
    wordBreak: 'break-word'
  },
  currencyCell: {
    whiteSpace: 'nowrap'
  },
  customAttributes: {
    display: 'flex'
  },
  notRegistered: {
    color: '#A4A4A4'
  },
  paymentState: {
    fontWeight: 500,
    marginLeft: 10
  },
  paymentAccrued: {
    backgroundColor: '#EAF3FF', // TODO - Get hex colour codes from constant style variables
    color: '#2D91E9',
    fontSize: 12,
    marginLeft: 10,
    padding: 3
  },
  iconButton: {
    padding: 0,
    '&.isResponsive': {
      justifyContent: 'left',
      '& .MuiTouchRipple-root': {
        display: 'none'
      }
    },
    '& .MuiSvgIcon-root':{
      marginLeft:17
    }
  },
  arrowIconButton: {
    marginLeft: 10
  },
  itemIcon: {
    marginRight: 10,
    height: 18,
    pointerEvents: 'none',
    '& img': {
      height: 18,
      width: 18,
      pointerEvents: 'none',
    }
  },
  downloadIcon: {
    marginRight: '6px',
    position: 'relative'
  },
  donwloadText: {
    textDecoration: 'none',
    color: '#2D91E9'
  },
  loadingIcon: {
    display: 'inline-block',
    marginRight: 15,
    verticalAlign: 'bottom'
  },
  downloadButton: {
    height: 18,
    padding: 0
  },
  invoiceDownloadError: {
    fontSize: 12,
    lineHeight: '18px',
    color: '#f44336',
    fontWeight: 400,
    margin: '0 10px 0 0',
    width: 105,
  }
});
